'use client'

import BusinessSolutionPage, { CommerceAppVisual } from '@/components/platform/v2/BusinessSolutionPage'
import { Block, Head } from '@/components/platform/v2/SolutionKit'
import { getSolution } from '@/data/solutions'

const CommerceSolutionPageComponent = () => (
    <BusinessSolutionPage
        config={{
            meta: getSolution('commerce'),
            eyebrow: 'Торговля и e-commerce',
            titleLines: ['Продажа не заканчивается', 'после кнопки «Оплатить»'],
            lead: 'Каталог, заказы, оплаты, клиентская база, доставка, приложение, лояльность и повторные продажи работают в одном контуре.',
            problems: [
                { title: 'Магазин отдельно от CRM' },
                { title: 'Онлайн- и офлайн-покупатель — два разных клиента' },
                { title: 'Повторные продажи зависят от рекламы' },
                { title: 'Лояльность существует отдельно от покупок' },
            ],
            flowTitle: 'Один покупатель во всех каналах',
            flow: [
                'Сайт / приложение / магазин',
                'Товар / каталог',
                'Заказ',
                'Оплата',
                'CRM',
                'Доставка / самовывоз',
                'Баллы / история',
                'Повторная покупка',
            ],
            flowNote: 'Один клиент независимо от того, купил он онлайн или пришёл в магазин.',
            visual: <CommerceAppVisual />,
            thesis: 'Клиент должен возвращаться к вам, а не снова искать вас в рекламе.',
            featuresTitle: 'Что даёт VCENTRE.ONE',
            features: [
                'Каталог и товары',
                'Интернет-магазин',
                'Приложение магазина',
                'Корзина и оплаты',
                'Доставка / самовывоз',
                'История заказов',
                'Лояльность',
                'Реферальная программа',
                'CRM',
                'Интеграции с 1С и платёжными системами',
            ].map((title) => ({ title })),
            extra: (
                <Block tone="quiet">
                    <Head
                        eyebrow="Направление развития"
                        title="Интеграции с маркетплейсами"
                        align="center"
                        text="Подключение маркетплейсов развивается как дополнительный внешний канал продаж."
                    />
                </Block>
            ),
        }}
    />
)

export default CommerceSolutionPageComponent
